import React from 'react'

import { SettingEdit } from './edit'
import { ComponentWithSubheader } from 'dash/shared'

export default class {
  static Edit = () => <ComponentWithSubheader path={['Admin', 'Settings']} component={SettingEdit} />
}
